import { useSocket } from '@mint-lib/ai-chat';
import { Launch } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';
import { getRouteApi } from '@mint/routing';

const routeApi = getRouteApi('/_secured');

const AgenticAiLink = () => {
  const { chatId } = useSocket();
  const navigate = routeApi.useNavigate();

  const handleNavigateToAiHub = () => {
    if (!chatId) {
      navigate({ to: '/ai-hub' });
    }

    navigate({
      to: '/ai-hub/$chatId',
      params: {
        chatId,
      },
    });
  };

  return (
    <Button
      variant={'plain'}
      onClick={handleNavigateToAiHub}
      className="flex flex-row items-center justify-center gap-1 self-center focus:outline-none"
    >
      <Launch />
      {'AI HUB'}
    </Button>
  );
};

export default AgenticAiLink;
